import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUsersQuery } from '../../hooks/queries/useUsersQuery';
import { CreateFormAccessBody } from '../../services/apiSLTP/qhse/forms/formAccess';
import ModalBody, { ModalProps } from '../modals/ModalBody';
import DropDown, { OptionType } from '../ui/DropDown';

interface AddFormAccessModalProps extends ModalProps {
    onCreateFormAccess: (data: CreateFormAccessBody) => void;
    groupId: string;
}

const AddFormAccessModal: React.FC<AddFormAccessModalProps> = ({ open, handleClose, onCreateFormAccess, groupId }) => {
    const { t } = useTranslation();
    const [selectedUser, setSelectedUser] = useState<OptionType | null>(null);

    const { data: dataUsers, isLoading: isUsersLoading } = useUsersQuery({ queries: { active: true } });

    const handleOk = () => {
        if (!selectedUser) return;
        onCreateFormAccess({
            userId: selectedUser.value,
            groupId,
        });
        setSelectedUser(null);
        handleClose();
    };

    const options: OptionType[] =
        dataUsers
            ?.filter((user) => !user.isSpecial)
            .map((u) => ({
                label: `${u.firstName} ${u.lastName}`,
                value: u._id,
            })) || [];

    return (
        <ModalBody title={t('userAccess')} subtitle={t('add')} open={open} handleClose={handleClose} onSubmit={handleOk}>
            <Box>
                <DropDown
                    items={options}
                    selectedItem={selectedUser}
                    handleChange={(_, value) => setSelectedUser(value)}
                    inputLabel={t('user')}
                    loading={isUsersLoading}
                />
            </Box>
        </ModalBody>
    );
};

export default AddFormAccessModal;
